import { render, staticRenderFns } from "./LandingHeader.vue?vue&type=template&id=47b5e35a&scoped=true&"
import script from "./LandingHeader.vue?vue&type=script&lang=js&"
export * from "./LandingHeader.vue?vue&type=script&lang=js&"
import style0 from "./LandingHeader.vue?vue&type=style&index=0&id=47b5e35a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b5e35a",
  null
  
)

export default component.exports